// React import not needed in React 17+ with new JSX transform
import { Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';

import Layout from './components/Layout/Layout';
import Dashboard from './pages/Dashboard';
import Residents from './pages/Residents';
import Payments from './pages/Payments';
import Expenses from './pages/Expenses';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import Login from './pages/Login';

// Simple auth context (to be expanded)
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { ProtectedRoute } from './components/Auth/ProtectedRoute';
import InstallPrompt from './components/pwa/InstallPrompt';

function App() {
  return (
    <AuthProvider>
      <NotificationProvider>
        <Box sx={{ display: 'flex', minHeight: '100vh', minWidth: 0, width: '100%', overflowX: 'hidden' }}>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          
          {/* Protected routes */}
          <Route path="/" element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }>
            <Route index element={<Dashboard />} />
            <Route path="residents" element={<Residents />} />
            <Route path="payments" element={<Payments />} />
            <Route path="expenses" element={<Expenses />} />
            <Route path="reports" element={<Reports />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
        <InstallPrompt />
      </Box>
      </NotificationProvider>
    </AuthProvider>
  );
}

export default App;